module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_tvb_black-1f374bc303c49b3b05c33ee525fa5e77.svg";